const config = {
  API_BASE_URL: "/api",
  ORIGIN: "https://localhost:8010/proxy",
  STRIPE_API_KEY:
    "pk_test_51Ht9RUEaUrzegpW3Pn1huv6WZzw7UhqUpg0owWq4kEe5RId7s5CrBWaqLZlJ5FN6DkkBpDjvtdCHk4yG1dX68gcv00VKAbNxX9",
};

export default config;